import { IAppState } from '../../common/state';
import { IFlatTourBookingSchedule } from '../../types/newbuildingHeader';

export function getFlatTourBookingSchedule(state: IAppState): IFlatTourBookingSchedule | null {
  return state.newbuildingFlatTourBookingSchedule;
}
